
import { Typography } from '@mui/material';

const PageSensitiveGroup = () => {
    return (<>
        <div>
            <ol>
                <li style={{ paddingBottom: '5pt' }}><Typography variant='h6'>Children</Typography>
                    <ul>
                        <li style={{paddingBottom:'5px'}}><b>Why they're sensitive:</b> Their lungs are still developing, and they breathe more air per pound of body weight than adults.</li>
                        <li><b>Health risks:</b> Respiratory infections, aggravated asthma, and long-term lung development issues.</li>
                    </ul>
                </li>
                <li style={{ paddingBottom: '5pt' }}><Typography variant='h6'>Older Adults</Typography>
                    <ul>
                        <li style={{paddingBottom:'5px'}}><b>Why they're sensitive:</b> Aging lungs and immune systems are less efficient at dealing with pollutants.</li>
                        <li><b>Health risks:</b> Increased risk of cardiovascular and respiratory diseases, including stroke and heart attacks.</li>
                    </ul>
                </li>
                <li style={{ paddingBottom: '5pt' }}><Typography variant='h6'>People with Heart or Lung Disease</Typography>
                    <ul>
                        <li style={{paddingBottom:'5px'}}><b>Examples:</b> Individuals with asthma, chronic obstructive pulmonary disease (COPD), congestive heart faliure, or coronary artery disease.</li>
                        <li><b>Health risks:</b> PM2.5 can trigger serious events like asthma attacks, hospital admissions, and even premature death.</li>
                    </ul>
                </li>
                <li style={{ paddingBottom: '5pt' }}><Typography variant='h6'>People with Diabetes</Typography>
                    <ul>
                        <li style={{paddingBottom:'5px'}}><b>Why they're sensitive:</b> They are at higher risk for cardiovascular complications, which PM2.5 can exacerbate.</li>
                        <li><b>Health risks:</b> Increased likelihood of heart attacks, inflammation, and impaired vascular function.</li>
                    </ul>
                </li>
            </ol>
        </div>
    </>);
}

export default PageSensitiveGroup;